<template>
    <v-app>
        <app-top-bar :menu="menu" :color="'linear-gradient(135deg, #00345F 0%, #0066B3 100%)'" :moduleName="'RESULTS MODULE'"/>
        <v-main>
        <router-view/>
        </v-main>
  </v-app>
</template>

<script>
import AppTopBar from '../components/AppTopAndSideBar.vue';

export default {
  components: { AppTopBar},
    name: 'AttendanceLayout',
    data: () => ({
        menu: [
            { text: 'Home', icon: 'mdi-view-dashboard', routerName: 'ModuleSelector' },
            { text: 'Record Scores', icon: 'mdi-pencil-box-outline', routerName: 'StudentScores' },
            { text: 'Print Result Sheets', icon: 'mdi-printer', routerName: 'ResultSheets' },
        ],
    }),
};
</script>